import React from 'react'
import styled from 'styled-components';

const StyledWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 aspect ratio */
  margin-bottom: 60px;
`;

const VideoWrapper = ({ children }) => (
  <StyledWrapper>
    {children}
  </StyledWrapper>
);

export default VideoWrapper;
